module.exports = __webpack_public_path__ + "img/pending.17a1f3a4.svg";